import { heldCyclesTotal, type AutopilotCycleSummary } from "@auto-pools/core";

export { heldCyclesTotal };

/**
 * The oldest held/opening/closing cycle's last exit-now valuation, across every one of them: the
 * figure a reader sees (equity, drawdown, "all time") reflects all of them together, so the
 * staleness warning must fire the moment the stalest one falls behind, not just the first. ISO-8601
 * UTC timestamps compare correctly as plain strings. Null while none has ever been valued.
 */
export function oldestExitNowAt(cycles: readonly AutopilotCycleSummary[]): string | null {
  const at = cycles
    .map((c) => c.exitNow.at)
    .filter((value): value is string => value !== null)
    .sort();
  return at[0] ?? null;
}

/**
 * A cycle whose opening spent funding but that has never been valued. The server's exit equity
 * (behind equity and drawdown; "all time" counts it at its funding) is unavailable while any such
 * cycle exists, so the freshness marker must say "not valued" instead of the age of the other
 * cycles' valuations, which `oldestExitNowAt` alone would report as current.
 */
export function unvaluedFunded(cycles: readonly AutopilotCycleSummary[]): boolean {
  return cycles.some((c) => c.funding !== null && c.exitNow.at === null);
}
